module.exports = __webpack_public_path__ + "static/sf1-3327176840d2e014f8ee2dbf8b178dc0.jpg";